import { styles } from "../home/cover_section";
import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { colors } from "../../utils/const";
import Link from "next/link";
import dynamic from "next/dynamic";
const Contact_Video = dynamic(() => import("@/components/contact_video"));
const Statistics = dynamic(() =>
  import("../../components/statistics/statistics")
);

export default function Expertise_And_Trust() {
  const { t, locale } = useI18n();

  return (
    <Box
      id="Expertise&Trust"
      data-section="Expertise&Trust"
      className="horizontal-safe-padding "
      sx={{
        paddingTop: {
          xs: "20px",
          sm: "40px",
          md: "70px",
          lg: "100px",
          xl: "100px",
        },
        paddingBottom: { xs: "40px", md: "80px" },
        display: "flex",
        flexDirection: "column",
        gap: "60px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "start", md: "center" },
          justifyContent: "space-between",
          gap: 5,
        }}
      >
        <Contact_Video type="why-contact" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "32px",
            width: { xs: "100%", md: "590px" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "24px",
            }}
          >
            <Box
              component="h2"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "18px",
                  md: "20px",
                  lg: "32px",
                },
                color: colors.blue,
                fontWeight: "600",
                p: 0,
                m: 0,
              }}
            >
              {t.pages_main_tags.whyContact.expertise.title}
            </Box>
            <Box
              sx={{
                fontSize: {
                  xs: "15px",
                  sm: "15px",
                  md: "18px",
                },
                lineHeight: 1.8,
                color: colors.light_baby_grey,
              }}
            >
              {t.pages_main_tags.whyContact.expertise.text}
            </Box>
          </Box>

          <Link href="/products" sx={{ "&:hover": { color: colors.white } }}>
            <Button
              aria-label="Explore more about our products"
              variant="outlined"
              sx={{
                ...styles.btn,
                width: { xs: "190px", md: "200px", lg: "230px" },
                padding: { xs: "26px 2px", md: "26px 2px", lg: "26px 5px" },
                gap: "8px",
                alignItems: "center",
              }}
            >
              <span> {t.pages_main_tags.whyContact.expertise.btn} </span>
              <span>
                <Box
                  component="img"
                  loading="lazy"
                  src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/arrow.png"
                  alt="arrow"
                  sx={{
                    width: { xs: "12px", md: "15px" },
                    height: { xs: "12px", md: "15px" },
                    transform: locale === "ar" ? "rotate(-90deg)" : "none",
                  }}
                />
              </span>
            </Button>
          </Link>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
            justifyContent: "space-around",
          },
        }}
      >
        {t.pages_main_tags.whyContact.expertise.statistic.map((item) => (
          <Statistics
            key={item.id}
            type="why-contact"
            num={item.count}
            suffix={item.sufTheous}
            text={item.text}
          />
        ))}
      </Box>
    </Box>
  );
}
